import { render, staticRenderFns } from "./RankedList.vue?vue&type=template&id=329d79d0&scoped=true"
import script from "./RankedList.vue?vue&type=script&lang=js"
export * from "./RankedList.vue?vue&type=script&lang=js"
import style0 from "./RankedList.vue?vue&type=style&index=0&id=329d79d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d79d0",
  null
  
)

export default component.exports